import { render, staticRenderFns } from "./DataTablesHeaderColumnComponent.vue?vue&type=template&id=0e761970&"
import script from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"
export * from "./DataTablesHeaderColumnComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sessions/wizardly-beautiful-ramanujan/mnt/bobino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e761970')) {
      api.createRecord('0e761970', component.options)
    } else {
      api.reload('0e761970', component.options)
    }
    module.hot.accept("./DataTablesHeaderColumnComponent.vue?vue&type=template&id=0e761970&", function () {
      api.rerender('0e761970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/DataTablesHeaderColumnComponent.vue"
export default component.exports